import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductRoadmapComponent } from './productRoadmap.component';
import { ProductRoadmapRoutingModule } from './productRoadmap-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectModule } from "ng-select";
import { BsDatepickerModule, ModalModule, TooltipModule } from 'ngx-bootstrap';
import { BoxRetalStampsModule } from '../share/boxRetalStamps/boxRetalStamps.module';
import { HistoryBoxModule } from '../history-box/history-box.module';
import { Select2ApiModule } from '../share/select2Api/select2Api.module';
import { BoxRetalStampsTHModule } from '../share/boxRetalStampsTH/boxRetalStampsTH.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    ProductRoadmapRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SelectModule,
    BsDatepickerModule.forRoot(),
    TooltipModule,
    BoxRetalStampsModule,
    HistoryBoxModule,
    Select2ApiModule,
    ModalModule,
    BoxRetalStampsTHModule,

  ],
  declarations: [ProductRoadmapComponent]
})
export class ProductRoadmapModule { }



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/productRoadmap/productRoadmap.module.ts